function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import morph from '../utils/morph.js';
var morphGroups = {};
var props = ['duration', 'delay', 'easing', 'fill', 'classes', 'style', 'duration', 'resize', 'useCSS', 'hideFromClone', 'keepToClone', 'tween', 'tweenFromOpacity', 'tweenToOpacity', 'waitFor', 'onEnd'];
var mods = ['resize', 'useCSS', 'hideFromClone', 'keepToClone', 'tween'];

function changeClass(ctx, action) {
  if (ctx.clsAction !== action) {
    ctx.clsAction = action;
    ctx.el.classList[action]('q-morph--invisible');
  }
}

function trigger(group) {
  if (group.animating === true || group.queue.length < 2) {
    return;
  }

  var _group$queue = _slicedToArray(group.queue, 2),
      from = _group$queue[0],
      to = _group$queue[1];

  group.animating = true;
  from.animating = true;
  to.animating = true;
  changeClass(from, 'remove');
  changeClass(to, 'remove');
  var cancelFn = morph(_objectSpread(_objectSpread({
    from: from.el,
    to: to.el,
    onToggle: function onToggle() {
      changeClass(from, 'add');
      changeClass(to, 'remove');
    }
  }, to.opts), {}, {
    onEnd: function onEnd(dir, aborted) {
      to.opts.onEnd !== void 0 && to.opts.onEnd(dir, aborted);

      if (aborted === true) {
        return;
      }

      from.animating = false;
      to.animating = false;
      group.animating = false;
      group.cancel = void 0;
      group.queue.shift();
      trigger(group);
    }
  }));

  group.cancel = function () {
    cancelFn(true); // abort

    group.cancel = void 0;
  };
}

function updateModifiers(mod, ctx) {
  var opts = ctx.opts;
  mods.forEach(function (name) {
    opts[name] = mod[name] === true;
  });
}

function insertArgs(arg, ctx) {
  var opts = typeof arg === 'string' && arg.length > 0 ? arg.split(':') : [];
  ctx.name = opts[0];
  ctx.group = opts[1];
  Object.assign(ctx.opts, {
    duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
    waitFor: opts[3]
  });
}

function updateArgs(arg, ctx) {
  if (arg.group !== void 0) {
    ctx.group = arg.group;
  }

  if (arg.name !== void 0) {
    ctx.name = arg.name;
  }

  var opts = ctx.opts;
  props.forEach(function (name) {
    if (arg[name] !== void 0) {
      opts[name] = arg[name];
    }
  });
}

function updateModel(name, ctx) {
  if (ctx.name === name) {
    var group = morphGroups[ctx.group]; // if group is not registered

    if (group === void 0) {
      morphGroups[ctx.group] = {
        name: ctx.group,
        model: name,
        queue: [ctx],
        animating: false
      };
      changeClass(ctx, 'remove');
    } // if model changed
    else if (group.model !== name) {
        group.model = name;
        group.queue.push(ctx);

        if (group.animating === false && group.queue.length === 2) {
          trigger(group);
        }
      }

    return;
  }

  if (ctx.animating === false) {
    changeClass(ctx, 'add');
  }
}

function updateValue(ctx, value) {
  var model;

  if (Object(value) === value) {
    model = '' + value.model;
    updateArgs(value, ctx);
    updateModifiers(value, ctx);
  } else {
    model = '' + value;
  }

  if (model !== ctx.model) {
    ctx.model = model;
    updateModel(model, ctx);
  } else if (ctx.animating === false && ctx.clsAction !== void 0) {
    // ensure HMR
    ctx.el.classList[ctx.clsAction]('q-morph--invisible');
  }
}

function destroy(el) {
  var ctx = el.__qmorph;

  if (ctx !== void 0) {
    var group = morphGroups[ctx.group];

    if (group !== void 0) {
      var index = group.queue.indexOf(ctx);

      if (index !== -1) {
        group.queue = group.queue.filter(function (item) {
          return item !== ctx;
        });

        if (group.queue.length === 0) {
          group.cancel !== void 0 && group.cancel();
          delete morphGroups[ctx.group];
        }
      }
    }

    if (ctx.clsAction === 'add') {
      el.classList.remove('q-morph--invisible');
    }

    delete el.__qmorph;
  }
}

export default {
  name: 'morph',
  inserted: function inserted(el, binding) {
    if (el.__qmorph !== void 0) {
      destroy(el);
      el.__qmorph_destroyed = true;
    }

    var ctx = {
      el: el,
      animating: false,
      opts: {}
    };
    updateModifiers(binding.modifiers, ctx);
    insertArgs(binding.arg, ctx);
    updateValue(ctx, binding.value);
    el.__qmorph = ctx;
  },
  update: function update(el, binding) {
    var ctx = el.__qmorph;
    ctx !== void 0 && updateValue(ctx, binding.value);
  },
  unbind: function unbind(el) {
    if (el.__qmorph_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qmorph_destroyed;
    }
  }
};